// The origin this app is served from, used to build copy-paste-accurate
// commands (install URL, login server URL). Read at call time so it's right
// for any deployment — never hardcoded. Falls back to a placeholder if window
// is somehow absent.

export function serverOrigin(): string {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "https://your-cairn-server";
}
